export function parseJson(value, fallback = null) {
  if (value === null || typeof value === 'undefined' || value === '') {
    return fallback
  }

  if (typeof value !== 'string') {
    return value
  }

  try {
    return JSON.parse(value)
  } catch (error) {
    return fallback
  }
}

export function readStorageJson(key, fallback = null, storage = localStorage) {
  return parseJson(storage.getItem(key), fallback)
}

export function cloneJson(value, fallback = null) {
  if (value === null || typeof value === 'undefined') {
    return fallback
  }

  try {
    return JSON.parse(JSON.stringify(value))
  } catch (error) {
    return fallback
  }
}
